module.exports = __webpack_public_path__ + "static/media/66.de5a7c18.png";